module.exports = __webpack_public_path__ + "img/diseno.728b1ec2.jpeg";